// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const ChooseLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.chooseLensFolder"
        description="Choose lens folder."
        defaultMessage="Choose Lens Folder"
    />
);
ChooseLensFolder.displayName = "ChooseLensFolder";

export const CreateLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createLensFolder"
        description="Create lens folder."
        defaultMessage="Create Lens Folder"
    />
);
CreateLensFolder.displayName = "CreateLensFolder";

export const CreateLensFolderHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createLensFolderHeader"
        description="Create lens folder header."
        defaultMessage="Set up a Lens Folder"
    />
);
CreateLensFolderHeader.displayName = "CreateLensFolderHeader";

export const CreateLensFolderSubHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createLensFolderSubHeader"
        description="Create lens folder sub header."
        defaultMessage="You need to set up a Lens Folder to submit your Lens."
    />
);
CreateLensFolderSubHeader.displayName = "CreateLensFolderSubHeader";

export const CreateNewLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createNewLensFolder"
        description="Create new lens folder."
        defaultMessage="+ Create new Lens Folder"
    />
);
CreateNewLensFolder.displayName = "CreateNewLensFolder";

export const CreateNewOrganizationAndLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createNewOrganizationAndLensFolder"
        description="Create new organization and lens folder."
        defaultMessage="+ Create new Organization and Lens Folder"
    />
);
CreateNewOrganizationAndLensFolder.displayName = "CreateNewOrganizationAndLensFolder";

export const CreateNewOrganizationButtonText = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.createNewOrganizationButtonText"
        description="Create new organization button text."
        defaultMessage="+ Create new Organization"
    />
);
CreateNewOrganizationButtonText.displayName = "CreateNewOrganizationButtonText";

export const LearnMore = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.learnMore"
        description="Learn more."
        defaultMessage="Learn More"
    />
);
LearnMore.displayName = "LearnMore";

export const LensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.lensFolder"
        description="Lens folder."
        defaultMessage="Lens Folder"
    />
);
LensFolder.displayName = "LensFolder";

export const LensFolderTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.lensFolderTooltip"
        description="Lens folder tooltip."
        defaultMessage="Lens Folder is a place to store and manage your lenses."
    />
);
LensFolderTooltip.displayName = "LensFolderTooltip";

export const LensInformation = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.lensInformation"
        description="Lens information."
        defaultMessage="Lens Information"
    />
);
LensInformation.displayName = "LensInformation";

export const Organization = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.organization"
        description="Organization."
        defaultMessage="Organization"
    />
);
Organization.displayName = "Organization";

export const OrganizationTooltip = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.organizationTooltip"
        description="Organization tooltip."
        defaultMessage="Your organization houses your Lens Folders and allows you to access additional features with Snapchat"
    />
);
OrganizationTooltip.displayName = "OrganizationTooltip";

export const SelectLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.selectLensFolder"
        description="Select lens folder."
        defaultMessage="Select a Lens Folder"
    />
);
SelectLensFolder.displayName = "SelectLensFolder";

export const SelectLensFolderHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.selectLensFolderHeader"
        description="Select lens folder header."
        defaultMessage="Select Lens Folder"
    />
);
SelectLensFolderHeader.displayName = "SelectLensFolderHeader";

export const SelectLensFolderSubHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.selectLensFolderSubHeader"
        description="Select lens folder sub header."
        defaultMessage="Select a Lens Folder to submit your Lens."
    />
);
SelectLensFolderSubHeader.displayName = "SelectLensFolderSubHeader";

export const SelectOrganization = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.selectOrganization"
        description="Select organization."
        defaultMessage="Select an Organization"
    />
);
SelectOrganization.displayName = "SelectOrganization";

export const SubmitLens = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.submitLens"
        description="Submit lens."
        defaultMessage="Submit Lens"
    />
);
SubmitLens.displayName = "SubmitLens";

export const UpdateExistingLens = (): ReactElement => (
    <FormattedMessage
        id="apps.submit.components.lensSpace.updateExistingLens"
        description="Update existing lens."
        defaultMessage="Update an Existing Lens"
    />
);
UpdateExistingLens.displayName = "UpdateExistingLens";
